export default __webpack_public_path__ + "static/media/acropass-line-care-patch-temporary.ddb295d9.png";